import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { AnimatePresence } from "framer-motion"
import { withRouter } from 'react-router-dom'

import {ListTile, Switch, Animation} from 'components'
import { DeleteDialogue, FeedbackModal, ShortcutsModal, NotiPermissionModal } from 'features'
import ContextMenu from '../ContextMenu'

import { FaKeyboard, FaThumbsUp, FaSignOutAlt, FaDownload } from 'react-icons/fa'
import * as actionCreators from 'store/actions'
import * as cssTheme from 'theme'

const Option = styled.div`
    display: flex;
    border-radius: 5px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    // border: 1px solid white;
    background-color: var(--secondary-color);
    :hover{
        filter:brightness(var(--brightness));
        // background-color: var(--focus-color);
    }
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    padding: 0.5rem 0.5rem 0 0.5rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
`

const Line = styled.hr`
    border-color: var(--secondary-accent-color);
`;

class ToolbarMenu extends Component {
    state = {
        mode: true
    }

    togglePreferencesHandler = (key) => {
        let updatedUser = {...this.props.user}
        if(key === 'theme'){
            const currentTheme = updatedUser['theme']
            updatedUser[key] = currentTheme === 'Dark' ? 'Light' : 'Dark'
            this.themeHandler(currentTheme === 'Dark' ? 'Light' : 'Dark')
        } else {
            updatedUser[key] = !updatedUser[key]
        }
        this.props.updateUser(updatedUser)
    }

    themeHandler = (nextTheme) => {
        let theme = nextTheme === 'Light' ? cssTheme.light 
                    : nextTheme === 'Dark' ? cssTheme.dark
                    : null;
        for (const [key, value] of Object.entries(theme)) {
            document.documentElement.style.setProperty(key,value);
        }
    
        for (const [key, value] of Object.entries(cssTheme.base)) {
            document.documentElement.style.setProperty(key,value);
        }
    }

    signOutHandler = () => {
        this.props.signOutApp()
    }

    feedbackHandler = () => {
        this.props.closeHandler()
        this.props.setModal(<FeedbackModal/>)
    }

    shortcutsHandler = () => {
        this.props.closeHandler()
        this.props.setModal(<ShortcutsModal/>, 'shortcutsModal')
    }

    render(){
        const preferences = {
            theme: {
                title: 'Dark mode',
                callback: () => this.togglePreferencesHandler('theme'),
                value: this.props.user['theme'] === 'Dark'
            },
            full_width: {
                title: 'Full width',
                callback: () => this.togglePreferencesHandler('full_width'),
                value: this.props.user['full_width']
            },
            item_divider: {
                title: 'Divider',
                callback: () => this.togglePreferencesHandler('item_divider'),
                value: this.props.user['item_divider']
            },
            // show_completed: {
            //     title: 'Show completed',
            //     callback: () => this.togglePreferencesHandler('show_completed'),
            //     value: this.props.user['show_completed']
            // },
            // show_archived: {
            //     title: 'Archived sections',
            //     callback: () => this.togglePreferencesHandler('show_archived'),
            //     value: this.props.user['show_archived']
            // },
        }

        const notifications = {
            app: {
                title: 'In-app',
                callback: () => this.togglePreferencesHandler('app_notifications'),
                value: this.props.user['app_notifications']
            },
            desktop: {
                title: 'Desktop',
                callback: () => {
                    if(Notification.permission === 'granted'){
                        this.togglePreferencesHandler('desktop_notifications')
                    } else if(Notification.permission === 'denied'){
                        this.props.setModal(<NotiPermissionModal/>, 'notiPermissionModal')
                    } else {
                        Notification.permission !== 'granted' && Notification.requestPermission(result => {
                            if(result === 'granted'){
                                this.togglePreferencesHandler('desktop_notifications')
                            }
                        })
                    }
                },
                value: this.props.user['desktop_notifications'] && Notification.permission === 'granted'
            }
        }

        return(
            <ContextMenu>
                <Title>Preferences</Title>
                {Object.values(preferences).map(preference => (
                    <Option onClick={preference['callback']}>
                        {preference['title']}
                        <Switch checked={preference['value']}/>
                    </Option>
                ))}

                <Title>Notifications</Title>
                {Object.values(notifications).map(preference => (
                    <Option onClick={preference['callback']}>
                        {preference['title']}
                        <Switch checked={preference['value']}/>
                    </Option>
                ))}

                <Line/>

                <ListTile text='Shortcuts' icon={<FaKeyboard style={{color: 'var(--icon-color)'}}/>} onSelect={this.shortcutsHandler}/>
                <ListTile text='Feedback' icon={<FaThumbsUp style={{color: 'var(--icon-color)'}}/>} onSelect={this.feedbackHandler}/>
                {/* Uncomment when download feature is ready */}
                {/* <ListTile text='Download' icon={<FaDownload style={{color: 'var(--icon-color)'}}/>} onSelect={() => window.open('https://atomicly.io/download')}/> */}
                <ListTile text='Sign out' icon={<FaSignOutAlt style={{color: 'var(--icon-color)'}}/>} onSelect={() => this.setState({showSignOut: true})}/>
                <AnimatePresence>
                    {this.state.showSignOut && 
                    <Animation animation='expand'>
                        <DeleteDialogue submitText='Confirm' onDelete={this.signOutHandler} closeHandler={() => this.setState({showSignOut: false})}/>
                    </Animation>}
                </AnimatePresence>
            </ContextMenu>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        // data: state.db.data,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,

        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateUser: (user) => dispatch(actionCreators.updateUser(user)),
        signOutApp: () => dispatch(actionCreators.signOutApp()),
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ToolbarMenu));